import { graphql } from "@opensea/graphql"

export const CurrencyChartColorFragment = graphql(`
  fragment CurrencyChartColor on Currency {
    imageUrl
  }
`)
